import React, { useState } from 'react';
import { ChevronsUpDown, Check, X } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';
import { Command, CommandEmpty, CommandInput, CommandItem, CommandList } from './ui/command';

// Type-to-search dropdown. options: [{ value, label, sub }]
export const SearchPicker = ({ value, options, onChange, placeholder, disabled, testId, emptyText = 'No matches' }) => {
  const [open, setOpen] = useState(false);
  const selected = options.find(o => o.value === value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" disabled={disabled} data-testid={testId}
          className="flex h-9 w-full items-center justify-between gap-1 rounded-sm border border-input bg-transparent px-2 text-xs text-left disabled:opacity-50 disabled:cursor-not-allowed hover:bg-slate-50">
          <span className={`truncate ${selected ? '' : 'text-muted-foreground'}`}>{selected ? selected.label : placeholder}</span>
          {selected && !disabled
            ? <X className="w-3.5 h-3.5 shrink-0 text-slate-400 hover:text-red-600" onClick={(e) => { e.stopPropagation(); onChange(null); }} data-testid={`${testId}-clear`} />
            : <ChevronsUpDown className="w-3.5 h-3.5 shrink-0 text-slate-400" />}
        </button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-80" align="start">
        <Command filter={(v, search) => (v.toLowerCase().includes(search.toLowerCase()) ? 1 : 0)}>
          <CommandInput placeholder="Type SKU or name…" data-testid={`${testId}-search`} />
          <CommandList className="max-h-72">
            <CommandEmpty>{emptyText}</CommandEmpty>
            {options.map(o => (
              <CommandItem className="group" key={o.value} value={`${o.label} ${o.sub || ''} ${o.value}`} onSelect={() => { onChange(o.value); setOpen(false); }} data-testid={`${testId}-opt-${o.value}`}>
                <Check className={`w-3.5 h-3.5 mr-2 ${o.value === value ? 'opacity-100' : 'opacity-0'}`} />
                <div className="min-w-0">
                  <div className="text-xs truncate">{o.label}</div>
                  {o.sub && <div className="text-[11px] text-slate-500 group-data-[selected=true]:text-white/80 truncate">{o.sub}</div>}
                </div>
              </CommandItem>
            ))}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};

export const customerOptions = (customers) => customers.map(c => ({
  value: c.id, label: c.customer_name || '(unnamed)',
  sub: [c.contact_person, c.email, c.phone].filter(Boolean).join(' · '),
}));
